import React, { useEffect, useRef } from 'react';

const AuthCallback: React.FC = () => {
    const sentRef = useRef(false);

    useEffect(() => {
        if (sentRef.current) return;
        sentRef.current = true;

        const query = new URLSearchParams(window.location.search);
        const code = query.get('code');
        const error = query.get('error');

        if (window.opener) {
            if (code) {
                window.opener.postMessage({ type: 'OAUTH_RESPONSE', payload: { code, error: null } }, window.location.origin);
            } else if (error) {
                window.opener.postMessage({ type: 'OAUTH_RESPONSE', payload: { code: null, error } }, window.location.origin);
            }
            setTimeout(() => window.close(), 500);
        } else {
            console.error("No opener window found. OAuth flow might be broken.");
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-neutral-900 text-white">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500 mb-4"></div>
            <h2 className="text-xl font-semibold">Completing Authentication...</h2>
            <p className="text-gray-400 mt-2">You can close this window if it doesn't close automatically.</p>
        </div>
    );
};

export default AuthCallback;
